import { render, staticRenderFns } from "./Sequences.vue?vue&type=template&id=f2ffe0e0&scoped=true&"
import script from "./Sequences.vue?vue&type=script&lang=js&"
export * from "./Sequences.vue?vue&type=script&lang=js&"
import style0 from "./Sequences.vue?vue&type=style&index=0&id=f2ffe0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ffe0e0",
  null
  
)

export default component.exports